import { useState } from 'react'
import styled from '@emotion/styled'
import { Menu } from '@emotion-icons/material/Menu'
import { MenuItemWrapper } from 'src/layout/toolbar/menu-item'
import { Divider, Popover, Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { useAuthData } from 'src/components/auth/util'
import { useParsedRouter } from 'src/layout/hooks/use-parsed-router'

import { Settings } from '@emotion-icons/material/Settings'
import { Logout } from '@emotion-icons/material/Logout'
import { useRouter } from 'next/router'
import { isFeatureEnabled } from 'src/utils/feature-flag'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'

const NavMenuPopover = styled(Popover)<{ position: 'new' | 'old' }>`
  .MuiPaper-root {
    top: ${(props) => (props.position === 'old' ? `60px !important` : 'unset !important')};
    bottom: ${(props) => (props.position === 'new' ? `60px !important` : 'unset !important')};
    right: 12px !important;
    background-color: #2b2f38;
    padding: ${Shapes.spacing[4]}px;
    min-width: 250px;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    border-color: 1px solid ${Colors.border};
    box-shadow: ${Colors.BOX_SHADOW};
  }
`

const NavMenuItem = styled(Typography)`
  cursor: pointer;
  font-size: 14px;
  padding: ${Shapes.spacing[4]}px;
  display: flex;
  align-items: center;
  gap: 12px;
`

export const NavMenuModalToogle = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)
  const authData = useAuthData()
  const { redirect } = useParsedRouter()
  const router = useRouter()
  const isOwnerRevealEnabled = isFeatureEnabled('owner-reveal')

  const open = Boolean(anchorEl)
  const id = open ? 'nav-menu' : undefined

  const onClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const onClose = () => {
    setAnchorEl(null)
  }

  const onAccountToggle = () => {
    onClose()
    void router.push('/settings/profile')
  }

  const onClickLogout = () => {
    redirect('/logout')
  }

  if (!authData) {
    return null
  }

  return (
    <>
      <MenuItemWrapper id={COMMANDAI_IDS_MAP.chromeBar['user-settings']} active={open} onClick={onClick}>
        <Menu size={16} />
      </MenuItemWrapper>
      <NavMenuPopover
        position={isOwnerRevealEnabled ? 'new' : 'old'}
        id={id}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={onClose}>
        <NavMenuItem variant="title2" onClick={onAccountToggle} color={Colors.textWhite}>
          <Settings size={16} color="rgba(167, 176, 185, 1)" />
          Settings
        </NavMenuItem>
        <Divider />
        <NavMenuItem variant="title2" onClick={onClickLogout} color={Colors.redMedium}>
          <Logout size={16} />
          Log Out
        </NavMenuItem>
      </NavMenuPopover>
    </>
  )
}
